module.exports = __webpack_public_path__ + "assets/diners-club-5868c1.svg";